import { render } from "./DeleteUnit.vue?vue&type=template&id=a033badc&scoped=true"
import script from "./DeleteUnit.vue?vue&type=script&lang=js"
export * from "./DeleteUnit.vue?vue&type=script&lang=js"

import "./DeleteUnit.vue?vue&type=style&index=0&id=a033badc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a033badc"]])

export default __exports__